// @flow weak

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9

/*
Simplify catching local keydown events. Use this as a child component. You can also wrap a child component which will
just be passed through.

Just pass a map of key names to handlers. Handlers can be functions or objects with a handler and whether or not to
stop propagation or prevent default.

<Keydown handlers={{
  escape: this.onEscapeKey,
  enter: {handler: this.onEnterKey, stopPropagation: true, preventDefault: true}
}}/>
*/

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import keycode from 'keycode';

const Keydown = createReactClass({
  displayName: 'Keydown',
  mixins: [PureRenderMixin],

  propTypes: {
    handlers: PropTypes.object.isRequired,
    isGlobalEvent: PropTypes.bool.isRequired,
  },

  getDefaultProps() {
    return {
      isGlobalEvent: false,
    };
  },

  getInitialState() {
    return {
      handlers: this.handlers(this.props.handlers),
    };
  },

  handlers(keyNamesToHandlers = {}) {
    return _.fromPairs(
      Object.keys(keyNamesToHandlers).map(keyName => {
        const keyCode = keycode(keyName);
        if (_.isUndefined(keyCode)) {
          throw new Error(`Unknown keycode for ${keyName}.`);
        }
        let handler = keyNamesToHandlers[keyName];
        if (_.isFunction(handler)) {
          handler = {
            handler,
          };
        }
        return [`${keyCode}`, handler];
      })
    );
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.handlers !== nextProps.handlers) {
      this.setState({
        handlers: this.handlers(this.props.handlers),
      });
    }
  },

  getEventTarget() {
    const ownNode = ReactDOM.findDOMNode(this);
    return this.props.isGlobalEvent ? document : ownNode;
  },

  componentDidMount() {
    this.getEventTarget().addEventListener('keydown', this.onKeyDown);
  },

  componentWillUnmount() {
    this.getEventTarget().removeEventListener('keydown', this.onKeyDown);
  },

  isTargetWithinOwnNode(targetNode) {
    const ownNode = ReactDOM.findDOMNode(this);
    return !!ownNode && ownNode.contains(targetNode);
  },

  isApplicableTarget(targetNode) {
    return this.props.isGlobalEvent || this.isTargetWithinOwnNode(targetNode);
  },

  onKeyDown(event) {
    const handlerConfig = this.state.handlers[event.keyCode];

    if (handlerConfig) {
      const handler = handlerConfig.handler;
      if (_.isFunction(handler) && this.isApplicableTarget(event.target)) {
        handler(event);
      }
      if (handlerConfig.stopPropagation) {
        event.stopPropagation();
      }
      if (handlerConfig.preventDefault) {
        event.preventDefault();
      }
    }
  },

  render() {
    return !this.props.children
      ? null
      : React.Children.only(this.props.children);
  },
});

export default Keydown;
